var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCupModal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6064 25.2656C35.5882 25.2657 42.7852 32.3001 42.7852 40.875C42.7852 49.4499 35.5882 56.4843 26.6064 56.4844C17.6246 56.4844 10.4277 49.4499 10.4277 40.875C10.4277 32.3001 17.6246 25.2656 26.6064 25.2656Z",
    fill: "#D1D5DF",
    stroke: "#173261",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.916 40.7313V32.3281H25.166V43.4336H35.2493V40.7313H27.916Z",
    fill: "#173261"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0588 90.78C96.6243 90.78 98.7834 88.3121 99.4173 87.0781H77.8459V90.78H93.0588Z",
    fill: "#D1D5DF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6925 90.78C59.127 90.78 56.9679 88.3121 56.334 87.0781H77.8459V90.78H62.6925Z",
    fill: "#D1D5DF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99.127 50.8564C99.3437 50.8202 99.7987 50.8027 100.242 50.9082C100.678 51.0118 100.897 51.1793 101.003 51.3379C101.074 51.4441 101.289 51.9005 101.454 52.8594C101.61 53.7667 101.699 54.9844 101.635 56.4824C101.507 59.4736 100.776 63.5024 98.873 68.2744C95.1148 77.6972 90.4339 80.1032 89.1172 80.709C89.1211 80.7066 88.789 80.805 87.8799 80.8887C87.073 80.9629 86.0435 81.0095 84.8809 81.0361C82.5526 81.0895 79.8487 81.0629 77.5635 81.0625H77.5625C75.2773 81.0629 72.5733 81.0895 70.2451 81.0361C69.0827 81.0095 68.0538 80.9629 67.2471 80.8887C66.3415 80.8053 66.0078 80.7074 66.0088 80.709C64.6918 80.103 60.011 77.6968 56.2529 68.2744C54.3497 63.5024 53.6201 59.4736 53.4922 56.4824C53.4281 54.9844 53.5156 53.7667 53.6719 52.8594C53.8371 51.9005 54.052 51.4441 54.123 51.3379C54.2293 51.1793 54.4484 51.0119 54.8838 50.9082C55.3275 50.8026 55.7833 50.8202 56 50.8564L56.1631 50.8838H98.9629L99.127 50.8564Z",
    fill: "#F3F7FF",
    stroke: "#D1D5DF",
    strokeWidth: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6844 37.106C69.6946 41.6155 72.5134 45.0095 74.1716 46.1428C73.3425 44.5323 72.5134 40.4702 75.8297 37.106C79.146 33.7418 77.2115 28.2482 75.8297 25.9219C77.4879 32.0955 74.1716 31.4692 71.6844 37.106Z",
    fill: "#64748B",
    fillOpacity: 0.12
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1648 41.431C76.6238 44.5437 78.8069 46.8865 80.091 47.6688C79.449 46.5571 78.8069 43.7532 81.3753 41.431C83.9436 39.1088 82.4454 35.3167 81.3753 33.7109C82.6595 37.9724 80.091 37.5401 78.1648 41.431Z",
    fill: "#64748B",
    fillOpacity: 0.12
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 94.8828,
    width: 110,
    height: 4.5625,
    fill: "#D1D5DF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5802 90.6351C102.208 90.6351 105.01 87.5502 105.833 86.0078H77.8358V90.6351H97.5802Z",
    fill: "#173261"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1685 90.6351C53.541 90.6351 50.7387 87.5502 49.916 86.0078H77.8358V90.6351H58.1685Z",
    fill: "#173261"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCupModal);
export default __webpack_public_path__ + "static/media/Cup-modal.60cce40cf7f24ea8d9cb989044514a2f.svg";
export { ForwardRef as ReactComponent };